import { atom } from 'recoil';

export const adminReportState = atom({
  key: 'adminReportState',
  default: null,
});
